// App.JSX is the Controller. This one is responsible for routing for all containers and loading global state CSS.
import React, { Component } from 'react';
import {Link, BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom";


// Style
import './css/app.css';
import './css/header.scss';
import './css/style.scss';
import './css/single-page.scss';
import './css/jobs.scss';




// Container
import Tasklist from './containers/tasklist.jsx';

// Components
import Header from './components/header.jsx';
import Landing from './components/landing.jsx';
import Footer from './components/footer.jsx';
import SinglePost from './components/singlepost.jsx';
import Career from './components/pages/career.jsx';
import Four04 from './components/pages/four04.jsx';

// Pages
import ThisIsUs from './components/pages/this-is-us.jsx';
import WorkAtBethard from './components/pages/work-at-bethard.jsx';
import MeetThePeople from './components/pages/meet-the-people.jsx';


// This is the main Class to load all the routes

class Controller extends Component {
  constructor(props) {
   super(props);
 }

  render() {
    return (
      <Router>
        <div className="App">
          <Route name="application" path="/" component={Header}/>
          <Switch>
            <Route name="application" exact path="/" component={Landing}/>
            <Route name="application" path="/article/:slug" component={SinglePost}/>
            <Route name="application" exact path="/page/this-is-us" component={ThisIsUs}/>
            <Route name="application" exact path="/page/work-at-bethard" component={WorkAtBethard}/>
            <Route name="application" exact path="/page/meet-the-people" component={MeetThePeople}/>
            <Route name="application" exact path="/page/career" component={Career}/>
            <Route name="application" exact path="/404" component={Four04}/>
            <Redirect to="/404" />
          </Switch>
          <Route name="application" path="/" component={Footer}/>
        </div>
      </Router>
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./client/controller.jsx